import {useEffect, useRef, useState} from 'react';

interface UseMyMaintenanceGradeMotionHintProps {
  visibleThreshold: number;
  onVisible?: () => void;
  isAlwaysExcute?: boolean;
}

function useIntersectionObserver({visibleThreshold, onVisible = () => {}, isAlwaysExcute = true}: UseMyMaintenanceGradeMotionHintProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isInView, setIsInView] = useState(false);
  const [hasExcuted, setHasExcuted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= visibleThreshold) {
            setIsInView(true);
            if (isAlwaysExcute || !hasExcuted) {
              onVisible();
              setHasExcuted(true);
            }
          } else {
            setIsInView(false);
          }
        });
      },
      {
        threshold: [visibleThreshold],
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return {ref, isInView};
}

export default useIntersectionObserver;
